import { getFormattedNumber } from "@utils/utils";

export const getFormattedAmount = amount => {
  return `${getFormattedNumber(parseInt(amount ?? "0"))} kr`;
};
